<template>
    <router-view/>
</template>

<script>
import {provide, ref} from 'vue'
export default {
  name: 'App',
  setup(){
    
  },
  components: {

  }
}
</script>

<style>
</style>
